<mat-progress-spinner mode="indeterminate" [diameter]="100" *ngIf="!message"></mat-progress-spinner>

<div class="block-ui-message-container" *ngIf="message">
    <mat-progress-spinner mode="indeterminate" [diameter]="35"></mat-progress-spinner>
    <span class="block-ui-message">{{ message }}</span>
</div>
